<template>
    <div>
        <div v-if="type === '01'">
            <div v-for="(item,index) in statisticsData.tableData">
                <div
                    style="margin-left: 50px;width:18px; display:inline-block; margin-top:40px; font-weight:bold; color:#FBF3CF; background-color:#FD7A7A; text-align:center;">
                    {{ index + 1 }}
                </div>
                <span>&nbsp;{{ item.title }}(总投票人数：{{ item.totalStuNum }}人)</span>
                <table class="contentTable" cellpadding="0" cellspacing="0">
                    <tr>
                        <td class="tdBorder tdBackColor" style="width:200px;">选项</td>
                        <td class="tdBorder tdBackColor" style="width:100px;">投票数</td>
                        <td class="tdBorder tdBackColor" style="width:100px;">百分比</td>
                    </tr>

                    <tr v-for="(list,i) in item.allOptions">
                        <td class="tdBorder tdBackColor" style="text-align:left; padding-left:5px;">{{ list.comboName }}</td>
                        <td class="tdBorder">{{ list.otherInfo }}</td>
                        <td class="tdBorder">{{ list.comboValue }}</td>
                    </tr>
                </table>
                <div class="tipsDiv">提示：单选题显示饼图；多选题显示柱状图；</div>
                <div :id="'chart_'+index" style="height:400px;"></div>
                <div v-if="index!==statisticsData.tableData.length-1" style="margin: 0 auto;width: 1000px">
                    <el-divider/>
                </div>
            </div>
        </div>

        <div v-if="type === '05'">
            <span>&nbsp;</span>
            <table class="contentTable" cellpadding="0" cellspacing="0" style="margin: 0 auto;width: 95%">
                <tr style="height:40px; font-weight:bold;">
                    <td class="tdBorder" style="width:50px;">排名</td>
                    <td class="tdBorder" style="width:100px;">教师姓名</td>
                    <td class="tdBorder" style="width:300px;">授课情况</td>
                    <td class="tdBorder" style="width:80px;">评分人数</td>
                    <td class="tdBorder" style="width:500px;">评价标准</td>
                    <td class="tdBorder" style="width:80px;">平均分</td>
                    <td class="tdBorder" style="width:80px;">总分</td>
                </tr>

                <template v-for="(item,index) in statisticsData.tableData">
                    <tr style="height:40px;">
                        <td class="tdBorder" :rowspan="item.questionContent.length"> {{ item.id }}</td>
                        <td class="tdBorder" :rowspan="item.questionContent.length"> {{ item.teaName }}</td>
                        <td class="tdBorder" :rowspan="item.questionContent.length" style="text-align:left; padding:10px 5px 10px 5px;">
                            <div v-for="(str,i) in item.courseInfo">
                                {{ str }}
                                <div v-if="i!==item.courseInfo.length-1">
                                    <br/><br/>
                                </div>
                            </div>
                        </td>
                        <td class="tdBorder" :rowspan="item.questionContent.length"> {{ item.totalStuNum }}</td>
                        <td class="tdBorder"> {{ item.questionContent[0] }}</td>
                        <td class="tdBorder"> {{ item.questionScore[0] }}</td>
                        <td class="tdBorder" :rowspan="item.questionContent.length"> {{ item.score }}</td>
                    </tr>
                    <template v-for="j in item.questionContent.length-1">
                        <tr style="height:40px;">
                            <td class="tdBorder">{{ item.questionContent[j] }}</td>
                            <td class="tdBorder">{{ item.questionScore[j] }}</td>
                        </tr>
                    </template>
                </template>

            </table>

        </div>


    </div>
</template>

<script>
import echarts from 'echarts'

export default {

    props: ['statisticsData', 'userCode','id'],
    data() {
        return {
            type: '',
            imageData: [],
        }
    },
    mounted() {
        this.type = this.statisticsData.type;
        if (this.type === '01') {
            this.$nextTick(() => {
                this.showChart();
            });
        }

        if (this.type === '05') {
            for (let i = 0; i < this.statisticsData.tableData.length; i++) {
                this.statisticsData.tableData[i].courseInfo = this.statisticsData.tableData[i].courseInfo.split('/ /');
                let questionContent = [];
                let score = [];
                let split = this.statisticsData.tableData[i].detail.split('| |');
                for (let j = 0; j < split.length; j++) {
                    questionContent.push(split[j].split("@@")[0])
                    score.push(split[j].split("@@")[1])
                }
                this.statisticsData.tableData[i].questionContent = questionContent;
                this.statisticsData.tableData[i].questionScore = score;
            }
        }
    },
    methods: {
        exportFile() {
            this.showLoadingMask("导出中,请稍后...");

            let form = {
                'id':this.id,
                'userCode':this.userCode,
                'image':this.imageData
            }
            this.$api.evaluateManage.questionnaireSurvey.exportFile({
                responseType: "blob",
                data: form
            }).then((res) => {
                const _this = this;
                const resultData = res.data;
                const fileReader = new FileReader();
                fileReader.onload = function () {
                    if (resultData.type == 'application/json') {
                        const jsonData = JSON.parse(fileReader
                            .result); // 说明是普通对象数据，后台转换失败
                        showNotify('错误', jsonData.msg, 'error', 3000);
                    } else {
                        const fileName = decodeURI(res.headers['content-disposition']
                            .split('fileName=')[1]);
                        _this.downloadFileByBlob(resultData, fileName);
                    }
                };
                fileReader.readAsText(resultData);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        /**生成图表*/
        showChart() {
            for (let i = 0; i < this.statisticsData.chart.chartData.length; i++) {
                var chartDiv = this.$echarts.init(document.getElementById('chart_' + i));
                chartDiv.showLoading({text: '正在努力的读取数据中...'});
                chartDiv.setOption(this.statisticsData.chart.chartData[i]);
                chartDiv.hideLoading();
                var imageObj = chartDiv.getDataURL('png');
                if (imageObj.toString().length > 0) {
                    this.imageData.push(this.base_encode(imageObj.toString().split(',')[1]));
                }
            }
        },
        base_encode(str) {
            str = str.replace(/\//g, '_a');
            str = str.replace(/\+/g, '_b');
            return str;
        },
        downloadFileByBlob(data, fileName) {
            let blob = new Blob([data], {
                type: "application/ms-excel;charset=utf-8"
            });

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
    }
}
</script>

<style scoped>
body {
    margin: 0;
    padding: 0;
    text-align: center;
}

.contentTable {
    margin-top: 15px;
    margin-left: 50px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    text-align: center;
}

.tdBorder {
    border-left: 1px solid black;
    border-bottom: 1px solid black;
}

.tipsDiv {
    margin-top: 20px;
    margin-left: 50px;
    margin-bottom: 5px;
    color: red;
}

/*body{*/
/*    margin:0;*/
/*    padding:0;*/
/*    !*background-color:#FDAD78;*!*/
/*    text-align:center;*/
/*}*/
</style>



// WEBPACK FOOTER //
// statistics.vue?1164ae04